import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllPersonnel, StateStatus } from '@guryou/redux';
const useResourcesNew = () => {
  const dispatch = useDispatch();
  const {
    data,
    status,
    version,
    entity
  } = useSelector(state => state.provider.personnel);
  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getAllPersonnel());
    }
  }, [dispatch, status]);
  return {
    data: data || [],
    status,
    version,
    entity
  };
};
export default useResourcesNew;